// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const AcquirerSearchIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "AcquirerSearch/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.667 11.667v2.5m3.333-2.5v2.5M2.5 17.5H10 3.333V8.333h13.334v2.084M2.5 8.333h15m-15-2.5L10 2.5l7.5 3.333"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M15.167 17.833a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333ZM18.333 18.333 17.5 17.5"
}));
export default AcquirerSearchIcon;
